export default __webpack_public_path__ + "static/media/portalBg.e776ad61.svg";